import React from 'react'
import Hero from './Hero';
import Body from './Body';
import Deployment from './Deployment';
import Cards from './Cards';
import { Link } from 'react-router-dom';
import { signInWithGoogle } from './firebase';
import {Navigate} from 'react-router-dom';

function Navbar() {
function unregister()
{
  
 localStorage.clear();

  
}

  return (
    <div>
<header className="text-gray-600 body-font  ">
  <div className="container mx-auto flex flex-wrap p-5 flex-col md:flex-row items-center ">
    <a className="flex title-font font-medium items-center text-gray-900 mb-4 md:mb-0">
    <img src='hackscript.png' className='logoimg'></img>
      <span className="ml-3 text-xl">HackScript</span>
    </a>
    <nav className=" md:mr-auto md:ml-4 md:py-1 md:pl-4 md:border-l md:border-gray-400	flex flex-wrap items-center text-base justify-center">
      <a className=" animat  mr-5  text-blue-900  hover:text-gray-900">Events</a>
      <a className=" animatmr-5  text-blue-900  hover:text-gray-900">LeaderBoard</a>
    </nav>

    < a href='https://earnest-starship-32aaae.netlify.app/'>
    <button className=" animated  inline-flex items-center  text-gray-900 bg-gray-100 border-0 py-2.5 rounded-lg  px-3 mfocus:outline-none hover:bg-gray-900 hover:text-gray-100 rounded text-base mt-4 md:mt-0">
Open Console

    </button>
    </a>
    <>
  <img
    id="avatarButton"
    type="button"
    
    data-dropdown-toggle="userDropdown"
    data-dropdown-placement="bottom-start"
    className="w-10 h-10 rounded-full cursor-pointer mx-7 bg-blue-100"
    src={localStorage.getItem("pics")}
    alt={localStorage.getItem("names")}
  />
  {/* Dropdown menu */}
  <div
    id="userDropdown"
    className="hidden z-10 w-44 bg-white rounded divide-y divide-gray-100 shadow dark:bg-white-700 dark:divide-gray-600"
    style={{
      position: "absolute",
      inset: "0px auto auto 0px",
      margin: 0,
      transform: "translate3d(0px, 427.333px, 0px)"
    }}
    data-popper-reference-hidden=""
    data-popper-escaped=""
    data-popper-placement="bottom-start"
  >
    <div className="py-3 px-4 text-sm text-gray-900">
      <div>{localStorage.getItem("names")}</div>
      <div className="font-medium truncate">{localStorage.getItem("mail")}</div>
    </div>
    <ul
      className="py-1 text-sm text-gray-700 dark:text-gray-200"
      aria-labelledby="avatarButton"
    >
      <li>
        <Link
          to="/dashboard"
          className="block py-2 px-4 text-gray-900  hover:bg-blue-500 hover:text-white"
        >
          Dashboard
        </Link>
      </li>
    </ul>
    <div className="py-1">
      <Link
        to ='/'
        onClick = {unregister}
        className="block py-2 px-4 text-sm text-gray-900  hover:bg-blue-500 hover:text-white"
      >
        
        Sign out
      </Link>
    </div>
  </div>
</>


  </div>
</header>
<Hero/>
<Body/>

<Deployment/>


    </div>
  )
}

export default Navbar